<template lang="pug">
v-sheet.px-4.pt-8.d-flex.flex-wrap.justify-center.page-home-quick-access(
  v-if="!loading"
)
  quick-access-card(
    v-for="({ title, img, link }, i) in items",
    :key="i",
    :title="title",
    :link="link",
    :img="img",
    :small="xs"
  )

</template>

<script>
import QuickAccessCard from "@/components/cards/QuickAccess.vue";

const _config = {
  mod: "quickAccess",
};

export default {
  data: () => ({
    loading: true,
    viewMoreTo: _config.path,
    title: _config.title,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ title, img, link }) => ({
        title,
        img: this.files + img,
        link: link || "",
      }));
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get()
      .then((this.loading = false));
  },
  components: {
    QuickAccessCard,
  },
};
</script>

<style>
.page-home-quick-access {
  gap: 20px;
}
</style>
